import type { ExecuteReleaseStrategyDto } from "common/models/api/models/ExecuteReleaseStrategyDto";
import type { ResponseReleaseStrategyExecuteDto } from "common/models/api/models/ResponseReleaseStrategyExecuteDto";
import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export default function useExecuteReleaseStrategy(
    options?: UseCustomMutationOptions<ResponseReleaseStrategyExecuteDto, unknown, ExecuteReleaseStrategyDto>,
): UseMutationResult<ResponseReleaseStrategyExecuteDto, unknown, ExecuteReleaseStrategyDto> {
    return useMutation(async (body: ExecuteReleaseStrategyDto) => {
        const res = await releaseStrategyApi.execute(body);
        return res.data;
    }, options);
}
